import { createContext as e, useContext as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/lib/context/createEntityConfigContext.tsx
function r() {
	let r = e(null);
	function i({ value: e, children: t }) {
		return /* @__PURE__ */ n(r.Provider, {
			value: e,
			children: t
		});
	}
	function a() {
		let e = t(r);
		if (e === null) throw Error("useEntityConfig must be used inside EntityConfigProvider");
		return e;
	}
	return {
		EntityConfigProvider: i,
		useEntityConfig: a
	};
}
//#endregion
//#region src/lib/EntityConfigError.ts
function i(e) {
	let t = [e.host, e.key].filter(Boolean).join(".");
	return t ? `${t}: ${e.message}` : e.message;
}
var a = class extends Error {
	code;
	issues;
	constructor(e, t) {
		super(`[util-entity-config] ${e}\n${t.map(i).join("\n")}`), this.name = "EntityConfigError", this.code = e, this.issues = t;
	}
};
//#endregion
//#region src/lib/helpers/getHostValueError.ts
function o(e) {
	return e === null ? "null" : Array.isArray(e) ? "array" : typeof e == "number" && Number.isNaN(e) ? "NaN" : typeof e;
}
function s(e, t) {
	switch (t.type) {
		case "string": return typeof e == "string" ? null : `Expected string, got ${o(e)}`;
		case "number": return typeof e == "number" && Number.isFinite(e) ? null : `Expected number, got ${o(e)}`;
		case "boolean": return typeof e == "boolean" ? null : `Expected boolean, got ${o(e)}`;
		case "string[]": return Array.isArray(e) ? e.every((e) => typeof e == "string") ? null : "Expected string[], got array with non-string items" : `Expected string[], got ${o(e)}`;
		case "enum": return typeof e == "string" && t.values.includes(e) ? null : `Expected one of ${t.values.join(", ")}, got ${JSON.stringify(e)}`;
		case "json": return null;
		default: throw Error(`Unsupported field ${JSON.stringify(t)}`);
	}
}
//#endregion
//#region src/lib/helpers/parseEnvValue.ts
function c(e) {
	return {
		ok: !0,
		value: e
	};
}
function l(e) {
	return {
		ok: !1,
		message: e
	};
}
function u(e, t) {
	switch (t.type) {
		case "string": return c(e);
		case "boolean": return e === "true" ? c(!0) : e === "false" ? c(!1) : l(`Expected "true" or "false", got "${e}"`);
		case "number": {
			let t = Number(e);
			return Number.isFinite(t) ? c(t) : l(`Expected a number, got "${e}"`);
		}
		case "string[]": return c(e.split(",").map((e) => e.trim()).filter((e) => e.length > 0));
		case "enum": return t.values.includes(e) ? c(e) : l(`Expected one of ${t.values.join(", ")}, got "${e}"`);
		case "json": try {
			return c(JSON.parse(e));
		} catch {
			return l(`Expected JSON, got "${e}"`);
		}
		default: throw Error(`Unsupported field ${JSON.stringify(t)}`);
	}
}
//#endregion
//#region src/lib/helpers/selectHost.ts
function d(e, t, n) {
	let r = e[t];
	if (r) return {
		name: t,
		values: r
	};
	if (n !== void 0) {
		let r = e[n];
		if (r) return console.warn(`[util-entity-config] Unknown hostname "${t}", using "${n}" entry`), {
			name: n,
			values: r
		};
	}
	throw new a("unknown-host", [{
		source: "host",
		host: t,
		message: `No entry for hostname "${t}"`
	}]);
}
//#endregion
//#region src/lib/resolveEntityConfig.ts
var f = "VITE_";
function p(e, t) {
	let n = e[t];
	if (!(typeof n != "string" || n === "")) return n;
}
function m(e) {
	return Array.isArray(e.default) ? [...e.default] : e.default;
}
function h(e, t) {
	let n = t.hostname ?? window.location.hostname, r = d(t.hosts, n, t.fallbackHost), i = [], o = {};
	for (let t of Object.keys(r.values)) t in e || i.push({
		source: "host",
		host: r.name,
		key: t,
		message: "Unknown key"
	});
	for (let [n, a] of Object.entries(e)) {
		let e = `${f}${n}`, c = p(t.env, e);
		if (c !== void 0) {
			let t = u(c, a);
			t.ok ? o[n] = t.value : i.push({
				source: "env",
				key: n,
				message: `${e}: ${t.message}`
			});
			continue;
		}
		let l = r.values[n];
		if (l !== void 0) {
			let e = s(l, a);
			e === null ? o[n] = l : i.push({
				source: "host",
				host: r.name,
				key: n,
				message: e
			});
			continue;
		}
		if (a.default !== void 0) {
			o[n] = m(a);
			continue;
		}
		a.required && i.push({
			source: "schema",
			key: n,
			message: "Required key is missing"
		});
	}
	if (i.length > 0) throw new a("invalid-config", i);
	return o;
}
//#endregion
//#region src/lib/createEntityConfig.tsx
function g(e, t) {
	let i = h(e, t), a = r();
	function o({ value: e = i, children: t }) {
		return /* @__PURE__ */ n(a.EntityConfigProvider, {
			value: e,
			children: t
		});
	}
	return {
		entityConfig: i,
		EntityConfigProvider: o,
		useEntityConfig: a.useEntityConfig
	};
}
//#endregion
//#region src/lib/defineEntityConfigSchema.ts
function _(e) {
	return e;
}
//#endregion
//#region src/lib/types/constants.ts
var v = {
	TRADEQUO: "tradequo",
	QUOMARKETS: "quomarkets"
}, y = Object.values(v), b = {
	LOCALHOST: "localhost",
	TRADINGVIEW_LOVFX: "tradingview.lovfx.com",
	TRADINGVIEW_FXCALC_AI: "tradingview.fxcalc.ai",
	TRADINGVIEW_QUOMARKETS_IO: "tradingview.quomarkets.io",
	TRADINGVIEW_TRADEQUO_IO: "tradingview.tradequo.io",
	TRADINGVIEW_TRADEQUO_COM: "tradingview.tradequo.com",
	TRADINGVIEW_QUOMARKETS_COM: "tradingview.quomarkets.com",
	TRADINGVIEW_QUOMARKETS_AI: "tradingview.quomarkets.ai",
	TRADINGVIEW_TRADEQUO_AI: "tradingview.tradequo.ai",
	TRADINGVIEW_TRADEQUO_ID: "tradingview.tradequo.id",
	HOME_LOVFX: "home.lovfx.com",
	HOME_FXCALC_AI: "home.fxcalc.ai",
	HOME_QUOMARKETS_IO: "home.quomarkets.io",
	HOME_TRADEQUO_IO: "home.tradequo.io",
	HOME_TRADEQUO_COM: "home.tradequo.com",
	HOME_QUOMARKETS_COM: "home.quomarkets.com",
	HOME_QUOMARKETS_AI: "home.quomarkets.ai",
	HOME_TRADEQUO_AI: "home.tradequo.ai",
	HOME_TRADEQUO_ID: "home.tradequo.id",
	CALC_LOVFX: "calc.lovfx.com",
	CALC_FXCALC_AI: "calc.fxcalc.ai",
	CALC_QUOMARKETS_IO: "calc.quomarkets.io",
	CALC_TRADEQUO_IO: "calc.tradequo.io",
	CALC_TRADEQUO_COM: "calc.tradequo.com",
	CALC_QUOMARKETS_COM: "calc.quomarkets.com",
	CALC_QUOMARKETS_AI: "calc.quomarkets.ai",
	CALC_TRADEQUO_AI: "calc.tradequo.ai",
	CALC_TRADEQUO_ID: "calc.tradequo.id"
}, x = _({
	ENTITY: {
		type: "enum",
		values: y,
		required: !0
	},
	APPLICATION_TITLE: {
		type: "string",
		required: !0
	},
	SUPPORTED_LOCALES: {
		type: "string[]",
		required: !0
	},
	IS_ACCOUNT_MASKED: {
		type: "boolean",
		default: !1
	}
}), S = _({}), C = _({}), w = _({
	CORE_URL: {
		type: "string",
		required: !0
	},
	TRADING_VIEW_URL: {
		type: "string",
		required: !0
	},
	PRIVACY_POLICY_URL: {
		type: "string",
		required: !0
	}
}), T = _({ IS_B2CORE_OAUTH_ENABLED: {
	type: "boolean",
	default: !1
} }), E = _({
	TRADING_API_URL: {
		type: "string",
		required: !0
	},
	CHART_SERVICE_URL: {
		type: "string",
		required: !0
	},
	PERSISTENCE_URL: {
		type: "string",
		required: !0
	},
	ID_BACKEND_URL: {
		type: "string",
		required: !0
	},
	ID_FRONTEND_URL: {
		type: "string",
		required: !0
	},
	CREATE_ACCOUNT_URL: {
		type: "string",
		required: !0
	},
	APPLICATION_EXCHANGE: {
		type: "string",
		required: !0
	}
}), D = _({
	IS_ALL_SETTINGS_LOCAL: {
		type: "boolean",
		default: !1
	},
	IS_SIGNALS_ENABLED: {
		type: "boolean",
		default: !1
	},
	IS_SIGNALS_STATISTICS_ENABLED: {
		type: "boolean",
		default: !1
	},
	CAN_APPLY_SAVED_LAYOUT: {
		type: "boolean",
		default: !1
	}
});
//#endregion
//#region src/lib/validateEntityConfigJson.ts
function O(e, t) {
	let n = [];
	for (let [r, i] of Object.entries(t)) {
		for (let t of Object.keys(i)) t in e || n.push({
			source: "host",
			host: r,
			key: t,
			message: "Unknown key"
		});
		for (let [t, a] of Object.entries(e)) {
			let e = i[t];
			if (e !== void 0) {
				let i = s(e, a);
				i !== null && n.push({
					source: "host",
					host: r,
					key: t,
					message: i
				});
				continue;
			}
			a.required && a.default === void 0 && n.push({
				source: "schema",
				host: r,
				key: t,
				message: "Required key is missing"
			});
		}
	}
	return n;
}
//#endregion
export { x as BASE_FIELDS, S as CRM_BACKOFFICE_FIELDS, C as CRM_BACKOFFICE_FLAGS, w as CRM_FRONTOFFICE_FIELDS, T as CRM_FRONTOFFICE_FLAGS, b as DEPLOYMENT_HOSTS, y as ENTITY_NAMES, v as EntitiesConst, a as EntityConfigError, E as TRADING_FIELDS, D as TRADING_FLAGS, g as createEntityConfig, r as createEntityConfigContext, _ as defineEntityConfigSchema, h as resolveEntityConfig, O as validateEntityConfigJson };
